var map = {
	"./audioimg/0001-XZ-01.jpg": "PdLB",
	"./audioimg/0002-A-01.jpg": "AeYp",
	"./audioimg/0003-A-01.jpg": "/XTF",
	"./audioimg/0004-A-01.jpg": "abfw",
	"./audioimg/0005-A-01.jpg": "35tN",
	"./audioimg/0006-A-01.jpg": "vCSq",
	"./audioimg/0007-A-01.jpg": "9rlt",
	"./audioimg/0008-A-01.jpg": "Xxex",
	"./audioimg/0009-A-01.jpg": "f+hq",
	"./audioimg/0010-A-01.jpg": "z63z",
	"./audioimg/0011-A-01.jpg": "/VOb",
	"./audioimg/0012-A-01.jpg": "mwRk",
	"./audioimg/0013-A-01.jpg": "Ecou"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SCBH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/audioimg.*$
// module id = SCBH
// module chunks = 0